module.exports = __webpack_public_path__ + "img/step6-06.9aec8510.jpg";